import type { ComponentProps, ReactNode } from 'react'
import Link from 'next/link'

export default function StyledLink({ children, ...props }: ComponentProps<typeof Link>): ReactNode {
  return (
    <Link className="group outline-hidden" {...props}>
      {children}
    </Link>
  )
}
